<template>
  <div>
    <modal v-show="isModalVisible" @close="closeModal" footer>
      <template v-slot:title>
        <h5>Update Bank</h5>
      </template>
      <template v-slot:body>
        <div>
          <div class="form-group">
            <label for="name">Name</label>
            <input
              type="text"
              class="form-control"
              v-model="service.name"
              placeholder="Bank Name"
            />
          </div>
          <div class=" form-group">
            <label for="icon_file">Image File</label>
            <img
              v-if="base_six !== ''"
              :src="base_six"
              alt=""
              class=" card--profile-image avatar d-block"
            />
            <img
              v-else-if="service.image !== null && service.image !== ''"
              :src="service.image"
              alt=""
              class=" card--profile-image avatar d-block"
            />
            <button
              class=" btn btn-secondary d-block mt-1"
              @click="onPickButton"
            >
              Upload Bank Image
            </button>
            <input
              type="file"
              class="upload"
              ref="fileChange"
              accept="*"
              style="display:none;"
              @change="onFilePickedButton"
            />
          </div>
          <div class="form-group">
            <label for="name">Bank Code</label>
            <input
              type="text"
              class="form-control"
              v-model="service.code"
              placeholder="Bank Name"
            />
          </div>
          <div class="form-group">
            <label for="name">Bank's General Code</label>
            <input
              type="text"
              class="form-control"
              v-model="service.general_code"
              placeholder="Bank's General Code"
            />
          </div>
          <div class="form-group">
            <label for="name">Bank's Etransact Code</label>
            <input
              type="text"
              class="form-control"
              v-model="service.etransact_code"
              placeholder="Bank's General Code"
            />
          </div>

          <div class="form-group">
            <label for="role">Status</label>
            <select
              name="role"
              id="role"
              v-model="service.status"
              class="form-control"
            >
              <option value="" selected disabled>Select status</option>
              <option
                :value="status.slug"
                v-for="status in statuses"
                :key="status.id"
                >{{ status.name }}</option
              >
            </select>
          </div>
          <div class="form-group">
            <label for="name">Order</label>
            <input
              type="text"
              class="form-control"
              v-model="service.order"
              placeholder="Order"
            />
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button
          type="button"
          class="button"
          :disabled="formLoading"
          @click.prevent="addBank"
        >
          <span class="custom-loader" v-if="formLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;">{{
              service.id ? "Updating bank..." : "Adding bank..."
            }}</span>
          </span>
          <span v-else>
            {{ service.id ? "Updating bank" : "Add bank" }}
          </span>
        </button>
        <button
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal"
        >
          Cancel
        </button>
      </template>
    </modal>
    <div
      v-if="getServicesLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Banks ready...</h3>
        </div>
      </div>
    </div>

    <div class="card card--no-shadow" v-else>
      <div class="card-header">
        <div class="row align-items-center justify-content-between mb-2">
          <div class="col">
            <h1 class="mb-2 font-regular">Banks</h1>
          </div>

          <div
            class="col-auto"
            @click="isModalVisible = true"
            v-if="permissions.includes('create-update-bank')"
          >
            <button class="btn btn-primary">Add Bank</button>
          </div>
        </div>
        <!-- <slot name="header">
          <h1 class="card-title">Services Tab</h1>
        </slot> -->
      </div>

      <div class=" row mb-1 px-2 py-1">
        <div class="col-lg-12">
          <CScrollbar
            class="nav nav-tabs nav-overflow header-tabs"
            :settings="psSettings"
            tag="ul"
          >
            <li class=" nav-item">
              <a
                href="javascript:void(0)"
                class=" nav-link"
                v-on:click="activetab = 1"
                v-bind:class="[activetab === 1 ? 'active' : '']"
              >
                Banks
              </a>
            </li>
            <li class=" nav-item">
              <a
                href="javascript:void(0)"
                class=" nav-link"
                v-on:click="activetab = 2"
                v-bind:class="[activetab === 2 ? 'active' : '']"
              >
                Update Banks In Group
              </a>
            </li>
          </CScrollbar>
        </div>
      </div>
      <div class="card-content">
        <div class="card-body" v-if="activetab === 1">
          <CDataTable
            :items="services"
            :fields="fields"
            :items-per-page="small ? 100 : 25"
            pagination
            sorter
            tableFilter
          >
            <template #img="{item}">
              <td>
                <img
                  :src="item.image"
                  alt="logo"
                  style="height: 50px; width: 50px;"
                />
              </td>
            </template>

            <template #action="{item}">
              <td
                class="table--action-mobile"
                v-if="permissions.includes('create-update-bank')"
              >
                <button
                  :disabled="!permissions.includes('create-update-bank')"
                  class="button"
                  :class="
                    permissions.includes('create-update-bank')
                      ? ''
                      : 'disabled cursor-not-allowed'
                  "
                  @click="updateBankModal(item)"
                >
                  Update
                </button>
              </td>
            </template>
          </CDataTable>
        </div>

        <div class="card-body" v-if="activetab === 2">
          <button class=" btn btn-primary mb-1" @click="updateGroup">
            <span class="custom-loader" v-if="groupLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
            </span>
            <span v-else style="font-weight: 600; text-transform: initial;">
              Update Group</span
            >
          </button>
          <div class="table-responsive">
            <table class=" table ">
              <tr>
                <th></th>
                <th>
                  Name
                </th>

                <th>Code</th>
                <th>
                  General Code
                </th>
                <th>
                  Etransact Code
                </th>
              </tr>
              <tr v-for="(item, index) of services" :key="index">
                <td>
                  <img
                    :src="item.image"
                    alt="logo"
                    style="height: 50px; width: 50px;"
                  />
                </td>
                <td>
                  {{ item.name }}
                </td>

                <td>
                  <input
                    type="text"
                    class="form-control"
                    v-model="item.code"
                    placeholder="Bank Code"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    v-model="item.general_code"
                    placeholder="Bank General Code"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    v-model="item.etransact_code"
                    placeholder="Bank General Code"
                  />
                </td>
              </tr>
            </table>
          </div>
          <button class=" btn btn-primary mb-1" @click="updateGroup">
            <span class="custom-loader" v-if="groupLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
            </span>
            <span v-else style="font-weight: 600; text-transform: initial;">
              Update Group</span
            >
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "@/components/CDataTable.vue";
import ApiService from "@/services/api.service";
import ErrorService from "@/services/error.service";
import CScrollbar from "@/components/CScrollbar";

import Swal from "sweetalert2";

const fields = ["img", "name", "category", "status", "action"];
export default {
  name: "Banks",
  components: {
    CDataTable,
    CScrollbar
  },
  data() {
    return {
      groupLoading: false,
      activetab: 2,
      small: true,
      statuses: [
        { id: "1", name: "Active", slug: "active" },
        { id: "2", name: "In-Active", slug: "inactive" }
      ],
      fields,
      services: [],
      formLoading: false,
      getServicesLoading: true,
      pageLoading: true,
      isModalVisible: false,
      service: {
        name: "",
        code: "",
        general_code: "",
        etransact_code: "",
        image: "",
        order: "",
        status: ""
      },
      imageFileType: "",
      filename: "",
      image: "",
      base_six: ""
    };
  },
  computed: {
    psSettings() {
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX:
          getComputedStyle(document.querySelector("html")).direction === "rtl",
        wheelPropagation: false
      };
    },
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  methods: {
    async mapNewArray() {
      const newArray = this.services.map(item => {
        return {
          id: item.id,
          name: item.name,
          general_code: item.general_code === null ? "" : item.general_code,
          etransact_code: item.etransact_code === null ? "" : item.etransact_code,
          code: item.code === null ? "" : item.code
        };
      });
      return newArray;
    },
    async updateGroup() {
      let arr = await this.mapNewArray();
      console.log(arr);
      try {
        this.groupLoading = true;
        const response = await ApiService.post("transfer/update-bank-group", {
          banks: arr
        });

        this.groupLoading = false;
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        await this.getServices();
      } catch (error) {
        console.log(error.response);
        console.log(error);
        let _error = error.response.data;
        this.groupLoading = false;
        console.log(_error);
        ErrorService.displayErrorAlert(_error);
      }
    },
    async addBank() {
      console.log(this.service);
      let formData = new FormData();
      formData.append("name", this.service.name);
      formData.append("code", this.service.code);
      formData.append("status", this.service.status);
      formData.append("general_code", this.service.general_code);
      formData.append("etransact_code", this.service.etransact_code);
      formData.append("id", this.service.id);
      formData.append("image", this.service.image);
      formData.append("order", this.service.order);
      // console.log(this.base_six);
      const headers = { "Content-Type": "multipart/form-data" };

      try {
        this.formLoading = true;
        const response = await ApiService.post(
          "transfer/create-update-bank",
          formData,
          { headers }
        );
        this.formLoading = false;

        this.closeModal();
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        await this.getServices();
      } catch (error) {
        console.log(error);
        let _error = error.response.data;
        this.formLoading = false;
        console.log(_error);
        ErrorService.displayErrorAlert(_error);
      }
    },
    onPickButton() {
      this.$refs.fileChange.click();
    },
    onFilePickedButton(event) {
      const files = event.target.files;
      let filename = files[0].name;
      this.filename = filename;
      this.imageFileType = files[0].type.match(/.(jpg|jpeg|png)$/i);
      if (filename.lastIndexOf(".") <= 0) {
        return alert("please add a valid file!");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        // this.service.image = fileReader.result;
        this.base_six = fileReader.result;
        // console.log(this.service.image);
        // console.log(this.service);
      });
      fileReader.readAsDataURL(files[0]);
      this.service.image = files[0];
    },
    updateBankModal(item) {
      console.log(item);
      this.service = Object.assign({}, item);
      this.isModalVisible = true;
    },
    closeModal() {
      this.base_six = "";
      this.isModalVisible = false;
      // this.service = null;
      this.service.name = "";
      this.service.code = "";
      this.service.general_code = "";
      this.service.etransact_code = "";
      this.service.image = "";
      this.service.order = "";
      this.service.status = "";
    },
    async getServices() {
      try {
        // this.getServicesLoading = true;
        const response = await ApiService.get("transfer/banks");
        console.log(response.data.data);
        this.services = response.data.data;
        this.getServicesLoading = false;
      } catch (error) {
        console.error(error);
        this.getServicesLoading = false;
      }
    }
  },
  mounted() {
    this.getServices();
  }
};
</script>

<style scoped></style>
